var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("footer", { staticClass: "footer" }, [
        _c("div", { staticClass: "in container" }, [
          _c("div", { staticClass: "footer__col" }, [
            _c("div", { staticClass: "in" }, [
              _c("h6", [_vm._v("Legal")]),
              _vm._v(" "),
              _c("div", { staticClass: "menu-legal-container" }, [
                _c("ul", { staticClass: "menu", attrs: { id: "menu-legal" } }, [
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-413",
                      attrs: { id: "menu-item-413" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/terms-and-conditions/"
                          }
                        },
                        [_vm._v("Terms & Conditions")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-414",
                      attrs: { id: "menu-item-414" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://themailingexpert.com/cookie-policy/"
                          }
                        },
                        [_vm._v("Cookie Policy")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1393",
                      attrs: { id: "menu-item-1393" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://themailingexpert.com/legal-privacy/"
                          }
                        },
                        [_vm._v("Privacy Policy")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer__col" }, [
            _c("div", { staticClass: "in" }, [
              _c("h6", [_vm._v("About")]),
              _vm._v(" "),
              _c("div", { staticClass: "menu-about-container" }, [
                _c("ul", { staticClass: "menu", attrs: { id: "menu-about" } }, [
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1394",
                      attrs: { id: "menu-item-1394" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://themailingexpert.com/about-us/"
                          }
                        },
                        [_vm._v("About Us")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1395",
                      attrs: { id: "menu-item-1395" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/why-the-mailing-expert/"
                          }
                        },
                        [_vm._v("Why The Mailing Expert")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1414",
                      attrs: { id: "menu-item-1414" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://themailingexpert.com/contact-us/"
                          }
                        },
                        [_vm._v("Contact Us")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer__col" }, [
            _c("div", { staticClass: "in" }, [
              _c("h6", [_vm._v("Products & Services")]),
              _vm._v(" "),
              _c("div", { staticClass: "menu-products-container" }, [
                _c(
                  "ul",
                  { staticClass: "menu", attrs: { id: "menu-products" } },
                  [
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-custom menu-item-object-custom menu-item-1409",
                        attrs: { id: "menu-item-1409" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "http://quote.themailingexpert.com/quotes-create"
                            }
                          },
                          [_vm._v("Mail & Franking")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1408",
                        attrs: { id: "menu-item-1408" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-xray/"
                            }
                          },
                          [_vm._v("Xray")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1406",
                        attrs: { id: "menu-item-1406" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-letter-openers/"
                            }
                          },
                          [_vm._v("Letter Openers")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1405",
                        attrs: { id: "menu-item-1405" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-inserting-machines/"
                            }
                          },
                          [_vm._v("Inserting Machines")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1407",
                        attrs: { id: "menu-item-1407" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-mfd-print-devices/"
                            }
                          },
                          [_vm._v("MFD Print Devices")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1404",
                        attrs: { id: "menu-item-1404" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-hybrid-mail/"
                            }
                          },
                          [_vm._v("Hybrid Mail")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "menu-item menu-item-type-post_type menu-item-object-page menu-item-1403",
                        attrs: { id: "menu-item-1403" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://themailingexpert.com/products-services-digitisation-and-scanning-2-2/"
                            }
                          },
                          [_vm._v("Digitisation and Scanning")]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer__col" }, [
            _c("div", { staticClass: "in" }, [
              _c("h6", [_vm._v("Help desk")]),
              _vm._v(" "),
              _c("div", { staticClass: "menu-help-container" }, [
                _c("ul", { staticClass: "menu", attrs: { id: "menu-help" } }, [
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1413",
                      attrs: { id: "menu-item-1413" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/let-us-do-it-for-you/"
                          }
                        },
                        [_vm._v("Let Us Do It For You")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1412",
                      attrs: { id: "menu-item-1412" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/product-support/"
                          }
                        },
                        [_vm._v("Product Support")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass:
                        "menu-item menu-item-type-post_type menu-item-object-page menu-item-1411",
                      attrs: { id: "menu-item-1411" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://themailingexpert.com/product-specification/"
                          }
                        },
                        [_vm._v("Product Specification")]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "complience" }, [
        _c("div", { staticClass: "in container" }, [
          _c("p", [
            _vm._v(
              "Themailingexpert.com uses cookies to offer you the best experience online. By continuing to use our website, you agree to the use of cookies. If you would like to know more about cookies and how to manage them please view our privacy & cookie policy."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "© 2019 themailingexpert.com. All rights reserved. Themailingexpert.com are trading names of Digital Mailing Solutions ltd."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "This website uses cookies. Continuing to use this website gives consent to cookies being used. For information on how to disable them see our cookie policy."
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "https://themailingexpert.com/cookie-policy/" }
                },
                [_vm._v("\n  Cookie Policy\n  ")]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://themailingexpert.com/terms-and-conditions/"
                  }
                },
                [_vm._v("\n  Terms & Conditions\n  ")]
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("\n  © TheMailingExpert.com - 2019\n  ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40209596", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40209596","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/Footer.vue
// module id = null
// module chunks = 